import React from "react";
import { useTranslation } from "react-i18next";

import {
  HvGlobalActions,
  HvTypography,
  HvGrid,
} from "@hitachivantara/uikit-react-core";

import useStyles from "./styles";
import PositioningContent from "./PositioningContent";

interface PositioningProps {
  mode?: "add" | "edit";
}

const Positioning: React.FC<PositioningProps> = () => {
  const { t } = useTranslation("cameraAddEdit");
  const classes = useStyles();

  return (
    <HvGrid container className={classes.root}>
      <HvGrid xs={12} sm={12} item>
        <HvGlobalActions title={t("positioning.title")} variant="section" />
        <HvTypography variant="normalText">
          {t("positioning.description")}
        </HvTypography>
      </HvGrid>
      <PositioningContent />
    </HvGrid>
  );
};

export default Positioning;
